import { Outlet, createRootRoute } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/state/server";

export const Route = createRootRoute({
  component: () => {
    return (
      <>
        <QueryClientProvider client={queryClient}>
          <Outlet />{" "}
        </QueryClientProvider>
      </>
    );
  },
});
